/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { isValidUUID } from '../../utils/functions';
import { configApi } from '../configApi';

interface IQueryParams {
  [key: string]: string | number;
}

export interface IResponseIdName {
  id: string;
  name: string;
}


export interface IParamsQuery {
  url: string;
  key: any[];
  refetchOnMount?: boolean;
  enable?: boolean;
}

export interface IRequestParams {
  currentPage?: number;
  itemPerPage?: number;
  inputSearch?: string;
  selectiveProcess?: string;
  id?: string;
  remove_pagination?: boolean;
  is_active?: boolean;
  step_id?: string;
  cache?: IResponseIdName[];
  type?: string;
  customQueryParams?: IQueryParams;
}

export type IParams = IParamsQuery & IRequestParams;

const requestData = async <T>(params: IParams): Promise<T | null> => {
  if (params.id) {
    if (!isValidUUID(params.id)) return null;

    if (params.cache) {
      const cached = params.cache?.find((cached) => cached.id === params.id);

      if (cached) return cached as T;
    }
  }

  const response = await configApi.get<T>(`${params.url}/${params.id ? params.id + '/' : ''}`, {
    params: {
      ...params?.customQueryParams,
      general_filter: params?.inputSearch,
      selective_process_id: params?.selectiveProcess,
      page_size: params?.itemPerPage,
      page: params?.currentPage,
      is_active: params.is_active,
      remove_pagination: params.remove_pagination,
      step_id: params.step_id,
    },
  });

  return response.data;
};

export const useRequestQuery = <T>(params: IParams) => {
  const { key, refetchOnMount, enable } = params;

  return useQuery({
    queryKey: key,
    queryFn: () => requestData<T>(params),
    refetchOnWindowFocus: false,
    refetchOnMount: refetchOnMount ?? undefined,
    enabled: enable || true,
  });
};
